import { CLIENT } from './config'
import { HEALTHCHECK_URL } from './endpoints'
import { StrapiClient, Strapi } from './strapi/strapi'
import { HomepageType } from './strapi/types/strapi-content'

type MaintenanceBanner = {
  title: string
  description: string
}

export const healthCheck = async (): Promise<void> => {
  await CLIENT.get<void>(HEALTHCHECK_URL)
}

export async function getMaintenanceBanner(
  strapiClient: StrapiClient = Strapi
): Promise<MaintenanceBanner | null> {
  try {
    const response = await strapiClient.getSingle<HomepageType>('/homepage', {
      populate: [
        'maintenance_banner.title',
        'maintenance_banner.description',
        'maintenance_banner.show_in_haver_view',
      ],
      publicationState: 'live',
    })

    if (
      response?.data?.attributes?.maintenanceBanner?.data?.attributes &&
      response.data.attributes.maintenanceBanner.data.attributes.showInHaverView
    ) {
      return {
        title: response.data.attributes.maintenanceBanner.data.attributes.title,
        description:
          response.data.attributes.maintenanceBanner.data.attributes.description,
      }
    }

    return null
  } catch (e) {
    // Suppress all errors for non-critical UI element
    return null
  }
}
